import styled from 'styled-components'

const WelcomeLayout = styled.div`
    position: relative;
    background-image: ${({ imageUrl = '' }) => `url(${imageUrl})`};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100vw;
    height: 100vh;
`

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 50px;
    z-index: 10;
    position: relative;
    top: 0;
    left: 0;
`

const Overlay = styled.div`
    background-color: #050505;
    opacity: 0.64;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

const WelcomeTitle = styled.div`
    font-size: ${({ $fontSize = '20px' }) => $fontSize};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.White};
    text-align: center;
`

const Subtitle = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.app.iconlabel};
    text-align: center;
`

const HighlightsLayout = styled.div`
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export {
    WelcomeLayout,
    Container,
    Overlay,
    WelcomeTitle,
    Subtitle,
    HighlightsLayout
}
